export const getToolLocaleKeyFromLayout = (
  layout: "Ideas" | "BudgetAllocator"
): string | "ideas" => {
  switch (layout) {
    case "Ideas":
      return "ideas";
    case "BudgetAllocator":
      return "budgetAllocator";
    default:
      return "ideas";
  }
};
